import {
  //useRef,
  useState,
} from "react";
import styled from "styled-components";
import { withAppHOC } from "../../hoc";
import {
  StyledContentContainer,
  StyledMainAreaContainer,
} from "../../components/styled";
import PageHeader from "../../components/PageHeader/PageHeader";
import {
  Form,
  Fieldset,
  Label,
  TextInput,
  MessageBox,
  Button,
  PasswordInput,
} from "../../components/FormElements";
import API from "../../api";
import { RESPONSE_STATUSES } from "../../constants";
import { getBase64, getReturnUrl } from "../../utils";

const StyledInput = styled.input`
  background-color: #f9fafb;
  font-size: 14px;
  font-weight: normal;
  color: #000000;
  padding: 15px;
  margin: 0px;
  border: 1px solid #ebebeb;
  border-radius: 5px;
  width: calc(100% - 32px);
  flex: 2;
  background-color: #f9fafb;
  outline: 0px;
`;

const SellerAPISupportCreate = () => {
  // const inputRef = useRef(null);
  const [state, setState] = useState({
    isLoading: false,
    responseStatus: "",
    responseMessage: "",
    url: "",
    username: "",
    password: "",
    supportNumber: "",
    serverIp: "",
    apiDocument: "",
    apiToken: "",
    apiKey: "",
    apiPin: "",
    apiRemark: "",
  });

  const onSubmit = async (e) => {
    e.preventDefault();
    setState((prevState) => ({
      ...prevState,
      isLoading: true,
      responseStatus: "",
      responseMessage: "",
    }));
    try {
      const response = await API.post("/help/seller-api-support", {
        url: state.url,
        username: state.username,
        password: state.password,
        supportNumber: state.supportNumber,
        serverIp: state.serverIp,
        apiDocument: state.apiDocument,
        apiToken: state.apiToken,
        apiKey: state.apiKey,
        apiPin: state.apiPin,
        apiRemark: state.apiRemark,
      });
      const { status, message } = response.data;
      if (status === RESPONSE_STATUSES.SUCCESS) {
        setState((prevState) => ({
          ...prevState,
          responseStatus: RESPONSE_STATUSES.SUCCESS,
          responseMessage: message,
          url: "",
          username: "",
          password: "",
          supportNumber: "",
          serverIp: "",
          apiDocument: "",
          apiToken: "",
          apiKey: "",
          apiPin: "",
          apiRemark: "",
        }));
        setTimeout(() => {
          setState((prevState) => ({
            ...prevState,
            responseStatus: "",
            responseMessage: "",
          }));
          window.location.href = getReturnUrl("create");
        }, 3000);
      } else {
        setState((prevState) => ({
          ...prevState,
          responseStatus: RESPONSE_STATUSES.FAILED,
          responseMessage: message,
        }));
      }
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        responseStatus: RESPONSE_STATUSES.FAILED,
        responseMessage: error.message,
      }));
    } finally {
      setState((prevState) => ({ ...prevState, isLoading: false }));
    }
  };

  const renderPageHeading = () => (
    <PageHeader
      title="Create Seller API Support Ticket"
      showBackButton={true}
    />
  );

  return (
    <>
      {renderPageHeading()}
      <StyledContentContainer>
        <StyledMainAreaContainer>
          <Form
            action="#"
            method="POST"
            onSubmit={onSubmit}
            style={{ maxWidth: "500px" }}
          >
            <Fieldset>
              <Label required>Website URL</Label>
              <TextInput
                value={state.url}
                onChange={(value) =>
                  setState((prevState) => ({
                    ...prevState,
                    url: value,
                  }))
                }
                placeholder="Website URL"
                disabled={state.isLoading}
              />
            </Fieldset>
            <Fieldset>
              <Label required>Username</Label>
              <TextInput
                value={state.username}
                onChange={(value) =>
                  setState((prevState) => ({
                    ...prevState,
                    username: value,
                  }))
                }
                placeholder="Username"
                disabled={state.isLoading}
              />
            </Fieldset>
            <Fieldset>
              <Label required>Password</Label>
              <PasswordInput
                value={state.password}
                onChange={(value) =>
                  setState((prevState) => ({
                    ...prevState,
                    password: value,
                  }))
                }
                placeholder="Password"
                disabled={state.isLoading}
              />
            </Fieldset>
            <Fieldset>
              <Label required>Support Number</Label>
              <TextInput
                value={state.supportNumber}
                isNumeric={true}
                onChange={(value) =>
                  setState((prevState) => ({
                    ...prevState,
                    supportNumber: value,
                  }))
                }
                placeholder="Support Number"
                disabled={state.isLoading}
              />
            </Fieldset>
            <Fieldset>
              <Label required>Server IP Address</Label>
              <TextInput
                value={state.serverIp}
                onChange={(value) =>
                  setState((prevState) => ({
                    ...prevState,
                    serverIp: value,
                  }))
                }
                placeholder="Server IP Address"
                disabled={state.isLoading}
              />
            </Fieldset>
            <Fieldset>
              <Label>API Token</Label>
              <TextInput
                value={state.apiToken}
                onChange={(value) =>
                  setState((prevState) => ({
                    ...prevState,
                    apiToken: value,
                  }))
                }
                placeholder="API Token"
                disabled={state.isLoading}
              />
            </Fieldset>
            <Fieldset>
              <Label>API Key</Label>
              <TextInput
                value={state.apiKey}
                onChange={(value) =>
                  setState((prevState) => ({
                    ...prevState,
                    apiKey: value,
                  }))
                }
                placeholder="API Key"
                disabled={state.isLoading}
              />
            </Fieldset>
            <Fieldset>
              <Label>API Pin</Label>
              <TextInput
                value={state.apiPin}
                onChange={(value) =>
                  setState((prevState) => ({
                    ...prevState,
                    apiPin: value,
                  }))
                }
                placeholder="API Pin"
                disabled={state.isLoading}
              />
            </Fieldset>
            <Fieldset>
              <Label>API Remark</Label>
              <TextInput
                value={state.apiRemark}
                onChange={(value) =>
                  setState((prevState) => ({
                    ...prevState,
                    apiRemark: value,
                  }))
                }
                placeholder="API Remark"
                disabled={state.isLoading}
              />
            </Fieldset>
            <Fieldset>
              <Label>API Documentation</Label>
              <StyledInput
                type="file"
                onChange={(e) => {
                  getBase64(e.target.files[0], (apiDocument) => {
                    setState((prevState) => ({
                      ...prevState,
                      apiDocument,
                    }));
                  });
                }}
                accept="application/pdf"
                disabled={state.isLoading}
              />
            </Fieldset>
            {state.responseStatus && state.responseMessage && (
              <Fieldset>
                <MessageBox
                  status={state.responseStatus}
                  message={state.responseMessage}
                />
              </Fieldset>
            )}
            <Fieldset>
              <Button disabled={state.isLoading}>Create</Button>
            </Fieldset>
          </Form>
        </StyledMainAreaContainer>
      </StyledContentContainer>
    </>
  );
};

export default withAppHOC(SellerAPISupportCreate);
